import { z } from "zod";

export const campaignDonorSchema = z.object({
  user_id: z.number(),
  name: z.string(),
  last_name: z.string().optional().nullable(),
  email: z.string().optional().nullable(),
  amount_in_cents: z.number(),
  created_at: z.string().datetime(),
  affiliation: z.string(),
});

export const campaignDonorsResponseSchema = z.object({
  results: z.array(campaignDonorSchema),
  total: z.number(),
});

export type CampaignDonor = z.infer<typeof campaignDonorSchema>;

export type CampaignDonorsResponse = z.infer<
  typeof campaignDonorsResponseSchema
>;
